import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "./index.css";
import config from "../../config";
import { getStorageItem } from "../../utils/sessionStorage";
import { toast } from "react-toastify";
const baseURL = config.ROOTURL.prod;

const ExpandedComponent = ({ data }) => {
  return <pre>{JSON.stringify(data, null, 2)}</pre>;
};

const RefferedToday = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const accessToken = getStorageItem("token");
  const [filterText, setFilterText] = useState("");
  const [influencerCode, setInfluencerCode] = useState("");
  const [currentCode, setCurrentCode] = useState("");
  const [champhuntId, setChamphuntId] = useState("62460584a1185e0d52b13e1e")

  const columns = [
    {
      name: "User Id",
      selector: (row) => row.userId,
    },
    {
      name: "User First Name",
      selector: (row) => row.userFirstName,
      sortable: true,
    },
    {
      name: "User Last Name",
      selector: (row) => row.userLastName,
      sortable: true,
    },
    {
      name: "User Email",
      selector: (row) => row.userEmail,
      sortable: true,
    },
    {
      name: "User Profile Photo",
      selector: (row) => row.userProfilePhoto,
    },
    {
      name: "Referral User Id",
      selector: (row) => row.referralUserId,
    },
    {
      name: "Refferal User First Name",
      selector: (row) => row.referralUserFirstName,
      sortable: true,
    },
    {
      name: "Refferal User Last Name",
      selector: (row) => row.referralUserLastName,
      sortable: true,
    },
    {
      name: "Refferal User Email",
      selector: (row) => row.referralUserEmail,
      sortable: true,
    },
    {
      name: "Refferal User Profile Photo",
      selector: (row) => row.referralUserProfilePhoto,
    },
    {
      name: "Created Date",
      selector: (row) => row.referralUserCreatedDate,
      sortable: true,
    },
    {
      name: "Share Mode",
      selector: (row) => row.shareMode,
    },
  ];

  const updateReferralCode = async () => {
    if (influencerCode === "") {
      return;
    }
    const updateData = {
      method: 'POST',
      url: global.config.ROOTURL.prod + `/invite/updateReferral/${champhuntId}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
      data: {
        secretCode: influencerCode,
      }
    }

    await axios(updateData)
      .then((response) => {
        console.log(response)
        setInfluencerCode("")
      }).catch((err) => {
        toast.error("Error in updating the SercetCode")
      })
  }

  useEffect(() => {
    axios
      .get(`${baseURL}/invite/getToday`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((response) => {
        ;
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error);
      });
  }, []);

  useEffect(async () => {
    await axios.post(global.config.ROOTURL.prod + `/invite/updateReferral/${champhuntId}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    }).then((response) => {
      setCurrentCode(response.data.secretCode)
    }).catch((err) => {
      console.log(err)
    })
  }, [influencerCode])

  const filteredData = data?.filter((item) => {
    return (
      item.userFirstName &&
      item.userFirstName.toLowerCase().includes(filterText.toLowerCase())
    );
  });

  return (
    <div className="refer">
      <div className="refer__wrapper">
        <div>
          <input
            type="text"
            className="refer__input"
            value={filterText}
            onChange={(e) => {
              setFilterText(e.target.value);
            }}
          />
          <button
            className="refer__clearButton"
            onClick={() => {
              setFilterText("");
            }}
          >
            Clear
          </button>
        </div>
        <div>
          <input
            type="text"
            className="refer__input"
            value={influencerCode}
            placeholder="Enter your Influencer Referral Code"
            onChange={(e) => {
              setInfluencerCode(e.target.value);
            }}
          />
          <button
            className="refer__clearButton"
            onClick={() => {
              updateReferralCode()
            }}
          >
            Update
          </button>
        </div>
        <div>
          <h2 className="refers__count">
            <span className="refers__total">Total: </span>
            {filteredData.length}
          </h2>
        </div>
      </div>
      <div>
        <div>
          <h4>Current Influencer Referral Code</h4>
          <p>{currentCode}</p>
          <p>{global.config.share_url}/invite/{champhuntId}/{currentCode}</p>
        </div>
      </div>
      {loading ? (
        <div style={{ textAlign: "center" }}>Loading...</div>
      ) : (
        <DataTable
          title="Reffered Users"
          columns={columns}
          data={filteredData}
          selectableRows
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          pagination
          highlightOnHover
          striped
        />
      )}
    </div>
  );
};

export default RefferedToday;
